import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VueTypedJs from "vue-typed-js";
import VuePageTransition from "vue-page-transition";

Vue.use(VueTypedJs);
Vue.use(VuePageTransition);

// LAYOUTS
import defaultLayout from "@/layouts/Default.vue";
import landingLayout from "@/layouts/Landing.vue";

Vue.component("default-layout", defaultLayout);
Vue.component("landing-layout", landingLayout);

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
